import { render, staticRenderFns } from "./Persons.vue?vue&type=template&id=2717c270&scoped=true&"
import script from "./Persons.vue?vue&type=script&lang=js&"
export * from "./Persons.vue?vue&type=script&lang=js&"
import style0 from "./Persons.vue?vue&type=style&index=0&id=2717c270&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717c270",
  null
  
)

export default component.exports